export default {
  'ticket.operator': 'المشغل',
  'ticket.status': 'الحالة',
  'ticket.lastupdate': 'آخر تحديث',
  'ticket.ticketid': 'معرّف الطلب',
  'ticket.subject': 'الموضوع',
  'ticket.total': 'إجمالي الطلبات',
  'ticket.notassigned': 'غير مخصص',
  'ticket.addnewticket': 'طلب جديد',
  'ticket.search': 'بحث',
  'ticket.knowleadgebase': 'قاعدة المعرفة',
  'ticket.announcements': 'الإعلانات',
  'ticket.description': 'الوصف',
  'ticket.mytickets': 'طلباتي',
  'ticket.knowledgebase': 'قاعدة المعرفة',
  'ticket.all': 'الكل',
  'ticket.done': 'منجز',
  'ticket.inprogress': 'قيد التقدم',
  'ticket.new': 'جديد',
  'ticket.ticketsInbox': 'صندوق الوارد',
  'ticket.ticketsUnread': 'غير مقروء',
  'ticket.close': 'إغلاق',
  'ticket.ticketType': 'نوع الطلب',
  'ticket.sender': 'المرسل',
  'ticket.findtickets': 'البحث عن الطلب',
  'ticket.newticket': 'طلب جديد',
  'ticket.send': 'إرسال',
  'ticket.uploadYourImage': 'تحميل الصورة',
  'ticket.indertSuccessFully': 'تم إرسال طلبك بنجاح',
  'ticket.text': 'نص',
  'ticket.insertSubject': 'يرجى إدخال موضوع طلبك',
  'ticket.insertText': 'يرجى إدخال نص طلبك',
  'ticket.insertMessageAndSubject': 'يرجى إدخال نص وموضوع طلبك',
  'ticket.items': 'العناصر',
  'ticket.item': 'العنصر',
  'ticket.submitinwriting': 'تقديم بالكتابة',
  'ticket.dateoforder': 'تاريخ الطلب',
  'ticket.dateoftravel': 'تاريخ السفر',
  'ticket.flight': 'رحلة',
  'ticket.details': 'تفاصيل',
  'ticket.responseaverage': 'متوسط الاستجابة',
  'ticket.supportnum': 'رقم الدعم',
  'ticket.support': 'دعم تريبسي',
  'ticket.minutes': 'دقائق',
  'ticket.reply': 'الرد',
  'ticket.supervisor': 'المشرف',
  'ticket.attachment': 'المرفقات',
  'ticket.preview': 'معاينة',
  'ticket.title': 'العنوان',
  'ticket.createddate': 'تاريخ الإنشاء',
  'ticket.ticketNumber': 'رقم الطلب',
  'ticket.message': 'الرسالة',
  'ticket.lastanswerdate': 'آخر تاريخ للرد',
  'ticket.attachphoto':
    'في هذا الجزء من قسم الطلب، يمكنك تحميل الصورة المطلوبة عبر الرابط أدناه.',
};
